// extracted by mini-css-extract-plugin
export default {"table":"B1N3t7QLG5grnSVcK0WH","spinnerContainer":"QcxZgUt5iKComkcoDqj4","spinner":"dNRbxQ7FfotyZdlxqqep","noRowsMessage":"acws6terspUooWUlVN3o"};